module.exports = __webpack_public_path__ + "media/assets/icons/earningrate-bluegray-500-7bfc5acdabc854c06bbdf9d5e2b6a6db.svg";